const wrapWithNetworkConditions = (fn, getDevState) => (...args) => {
  const devState = getDevState();
  switch (devState.type) {
    case "BROKEN": {
      const { status, delay, response } = devState;
      return new Promise(
        (_resolve, reject) => setTimeout(() => reject(new MockHttpError({ status, response })), delay * 1e3)
      );
    }
    case "DELAYED": {
      const { delay } = devState;
      return Promise.all([fn(...args), new Promise((r) => setTimeout(r, delay * 1e3))]).then(
        ([result]) => result
      );
    }
    default: {
      return fn(...args);
    }
  }
};
const MOCK_REQUEST_ID = "requestIdMock";
class MockHttpError extends Error {
  constructor(props) {
    super();
    this.response = { status: props.status, requestId: MOCK_REQUEST_ID, ...props.response };
  }
}
export {
  wrapWithNetworkConditions
};
//# sourceMappingURL=wrap-with-network-conditions.js.map
